import { CartAddEvent, CartErrorEvent } from '@theme/events';

if (!customElements.get('cro-accessory-rail')) {
  customElements.define(
    'cro-accessory-rail',
    class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.cro-acc__grid');
        this.prev = this.querySelector('.cro-acc__arrow--prev');
        this.next = this.querySelector('.cro-acc__arrow--next');
        this.prev?.addEventListener('click', () => this.slide(-1));
        this.next?.addEventListener('click', () => this.slide(1));

        this.addEventListener('change', (e) => {
          const select = e.target.closest('.cro-acc__variant-select');
          if (!select) return;
          const card = select.closest('.cro-acc__card');
          const option = select.selectedOptions[0];
          const idInput = card.querySelector('input[name="id"]');
          if (idInput && option.value) idInput.value = option.value;
          const price = card.querySelector('.cro-acc__price');
          if (price && option.dataset.price) price.textContent = option.dataset.price;
        });

        this.addEventListener('submit', this.onSubmit);
      }

      onSubmit = async (e) => {
        const form = e.target.closest('.cro-acc__form');
        if (!form) return;
        e.preventDefault();

        const id = form.querySelector('input[name="id"]')?.value;
        if (!id) return;

        const button = form.querySelector('.cro-acc__atc');
        this.setLoading(button, true);

        const sectionIds = [];
        document.querySelectorAll('cart-items-component').forEach((el) => {
          if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
        });

        try {
          const response = await fetch(`${Theme.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionIds.join(',') }),
          });

          if (!response.ok && response.status !== 422) throw new Error(`HTTP error! status: ${response.status}`);

          const data = await response.json();

          if (data.status) {
            const message = data.message || data.description || 'Could not add this item to your cart.';
            window.dispatchEvent(new CartErrorEvent(this.id, message));
            this.dispatchEvent(
              new CartAddEvent({}, String(id), {
                didError: true,
                source: 'cro-accessory-rail',
                itemCount: 1,
                productId: form.dataset.productId,
              })
            );
            return;
          }

          this.dispatchEvent(
            new CartAddEvent(data, String(id), {
              source: 'cro-accessory-rail',
              itemCount: 1,
              productId: form.dataset.productId,
              sections: data.sections,
            })
          );
        } catch (error) {
          form.submit();
        } finally {
          this.setLoading(button, false);
        }
      };

      setLoading(button, isLoading) {
        if (!button) return;
        button.toggleAttribute('disabled', isLoading);
        button.setAttribute('aria-busy', String(isLoading));
        button.style.opacity = isLoading ? '0.6' : '';
      }

      slide(dir) {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        if (max <= 4) return;
        if (dir > 0 && this.rail.scrollLeft >= max - 4) {
          this.rail.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (dir < 0 && this.rail.scrollLeft <= 4) {
          this.rail.scrollTo({ left: max, behavior: 'smooth' });
        } else {
          this.rail.scrollBy({ left: dir * Math.round(this.rail.clientWidth * 0.5), behavior: 'smooth' });
        }
      }
    }
  );
}
